import type { ComponentProps } from 'react'
import { classNames } from '~/utils/client/helpers'

export const Title = ({ className, ...otherProps }: ComponentProps<'h1'>) => {
  return <h1 {...otherProps} className={classNames('text-2xl font-bold', className)} />
}

export const SmallTitle = ({ className, ...otherProps }: ComponentProps<'h2'>) => {
  return <h2 {...otherProps} className={classNames('text-xl font-bold', className)} />
}

export const Highlighted = ({ className, ...otherProps }: ComponentProps<'h4'>) => {
  return (
    <h4 {...otherProps} className={classNames('text-base text-black font-semibold', className)} />
  )
}

export const Info = ({ className, ...otherProps }: ComponentProps<'span'>) => {
  return <span {...otherProps} className={classNames('text-sm text-secondary', className)} />
}

export const Detail = ({ className, ...otherProps }: ComponentProps<'span'>) => {
  return (
    <span {...otherProps} className={classNames('text-sm text-heading font-medium', className)} />
  )
}

export const Label = ({ className, ...otherProps }: ComponentProps<'label'>) => {
  return (
    <label {...otherProps} className={classNames('text-xs text-body font-medium', className)} />
  )
}

export const Small = ({ className, ...otherProps }: ComponentProps<'small'>) => {
  return <small {...otherProps} className={classNames('text-xs', className)} />
}

export const Paragraph = ({ className, ...otherProps }: ComponentProps<'p'>) => {
  return <p {...otherProps} className={classNames('text-base font-font', className)} />
}
